import { Routes } from "@angular/router";
import { AuthGuard } from "../../core/guards/auth-guard.service";
import { PermissionGuard } from "@core/guards/permission.guard";

export const organizacionRoutes: Routes = [
  {
    path: "org_dashboard",
    loadComponent: () =>
      import("./components/dashboard/dashboard.component").then(
        (m) => m.OrgDashboardComponent,
      ),
    data: {
      label: "Dashboard Organización",
      icon: "dashboard",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_inicio",
    loadComponent: () =>
       import("./components/dashboard/dashboard.component").then(
        (m) => m.OrgDashboardComponent,
      ),
    data: {
      label: "Inicio",
      icon: "home",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_entes",
    loadComponent: () =>
      import("./components/entes/entes.component").then(
        (m) => m.EntesComponent,
      ),
    data: {
      label: "Entes",
      icon: "home",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_descripcion-puestos",
    loadComponent: () =>
      import("./components/descripcion-puestos/descripcion-puestos.component").then(
        (m) => m.DescripcionPuestosComponent,
      ),
    data: {
      label: "Descripción de Puestos",
      icon: "home",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_tipos-clasificacion",
    loadComponent: () =>
      import("./components/tipos-clasificacion/tipos-clasificacion.component").then(
        (m) => m.TiposClasificacionComponent,
      ),
    data: {
      label: "Tipos de Clasificación",
      icon: "category",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },

  {
    path: "org_niveles-nodo",
    loadComponent: () =>
      import("./components/niveles-nodo/niveles-nodo.component").then(
        (m) => m.NivelesNodoComponent,
      ),
    data: {
      label: "Niveles de Nodo",
      icon: "layers",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_organigrama",
    loadComponent: () =>
      import("./components/gestion-organigramas/gestion-organigramas.component").then(
        (m) => m.GestionOrganigramasComponent,
      ),
    data: {
      label: "Gestión de Organigramas",
      icon: "account_tree",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_clasificacion-nodos",
    loadComponent: () =>
      import("./components/clasificacion-nodos/clasificacion-nodos.component").then(
        (m) => m.ClasificacionNodosComponent,
      ),
    data: {
      label: "Clasificación de Nodos",
      icon: "account_tree",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_niveles-bandasal",
    loadComponent: () =>
      import("./components/banda-salarial/banda-salarial.component").then(
        (m) => m.BandaSalarialComponent,
      ),
    data: {
      label: "Niveles de Banda Salarial",
      icon: "home",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_niveles-bandasal/niveles-bs-clase",
    loadComponent: () =>
      import("./components/banda-salarial/niveles-bs-clase/niveles-bs-clase.component").then(
        (m) => m.NivelesBsClaseComponent,
      ),
    data: {
      label: "Niveles por Clase de Banda Salarial",
      icon: "home",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_bandasal",
    loadComponent: () =>
      import("./components/banda-salarial/banda-salarial/bandasal.component").then(
        (m) => m.BandasalComponent,
      ),
    data: {
      label: "Banda Salarial",
      icon: "home",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_entes/editar",
    loadComponent: () =>
      import("./components/entes/entes-edit/entes-edit.component").then(
        (m) => m.EntesEditComponent,
      ),
    data: {
      label: "Editar Ente",
      icon: "edit",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_entes/sedes",
    loadComponent: () =>
      import("./components/entes/sedes/sedes.component").then(
        (m) => m.SedesComponent,
      ),
    data: {
      label: "Sedes",
      icon: "location_city",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_organigrama/nodos",
    loadComponent: () =>
      import("./components/gestion-organigramas/nodos-listado/nodos-listado.component").then(
        (m) => m.NodosListadoComponent,
      ),
    data: {
      label: "Nodos del Organigrama",
      icon: "account_tree",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "org_organigrama/vista",
    loadComponent: () =>
      import("./components/gestion-organigramas/organigrama-vista-full/organigrama-vista-full.component").then(
        (m) => m.OrganigramaVistaFullComponent,
      ),
    data: {
      label: "Vista de Organigrama",
      icon: "account_tree",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },

  {
    path: "org_tipos-clasificacion/clasificaciones",
    loadComponent: () =>
      import("./components/tipos-clasificacion/clasificaciones/clasificaciones.component").then(
        (m) => m.ClasificacionesComponent,
      ),
    data: {
      label: "Clasificaciones por Tipo",
      icon: "list",
      urlexterna: "RH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
];
